import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-762625be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "race-info-container" }
const _hoisted_2 = { class: "race-info-extra__block" }
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Ran at ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Running ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Running in ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_8 = { class: "race-info-extra__block" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__armor" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__neon" }, null, -1))
const _hoisted_12 = { class: "hound-card__info" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" LEAVE RACE ")
const _hoisted_14 = {
  key: 2,
  style: {"margin-left":".5rem"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" won ")
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" (")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_19 = { class: "hound-card__stats" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" No participants yet. Be the first to join! ")
const _hoisted_21 = {
  key: 3,
  style: {"padding":"2rem 0"}
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode("STARTING RACE...")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("JOIN RACE")
const _hoisted_24 = {
  key: 4,
  style: {"padding":"2rem 0"}
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 2D ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 3D ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_h2 = _resolveComponent("n-h2")!
  const _component_timer = _resolveComponent("timer")!
  const _component_n_statistic = _resolveComponent("n-statistic")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_refresh_icon = _resolveComponent("refresh-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button_group = _resolveComponent("n-button-group")!
  const _component_hound_select_modal = _resolveComponent("hound-select-modal")!
  const _component_n_modal = _resolveComponent("n-modal")!
  const _component_n_collapse_transition = _resolveComponent("n-collapse-transition")!

  return (_openBlock(), _createBlock(_component_n_collapse_transition, { collapsed: _ctx.show }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock("div", {
          key: _ctx.race.id,
          class: "race-info"
        }, [
          (_ctx.raceType === 'live')
            ? (_openBlock(), _createBlock(_component_n_space, {
                key: 0,
                class: "race-info-extra",
                vertical: "",
                style: {"margin-bottom":"1rem"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_n_h2, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_text, {
                            type: "primary",
                            style: {"font-family":"'syncopate'","text-transform":"uppercase"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.race.name), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.raceState === 'ended')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_n_text, null, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_n_text, {
                              type: "info",
                              strong: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.raceStartDate), 1)
                              ]),
                              _: 1
                            })
                          ], 64))
                        : (_ctx.raceState === 'live')
                          ? (_openBlock(), _createBlock(_component_n_text, { key: 1 }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }))
                          : (_ctx.raceState === 'upcoming')
                            ? (_openBlock(), _createBlock(_component_n_text, { key: 2 }, {
                                default: _withCtx(() => [
                                  _hoisted_6,
                                  _createVNode(_component_timer, {
                                    asTag: false,
                                    minutes: _ctx.minutesRemaining
                                  }, null, 8, ["minutes"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                      _createVNode(_component_n_text, null, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_n_text, {
                        type: "info",
                        strong: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.race.arena.name), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_n_space, { "item-style": "padding: 1.5rem" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_statistic, {
                          label: "Distance",
                          style: {"text-align":"center"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_text, { type: "info" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.race.arena.distanceType()), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_n_divider, {
                          vertical: "",
                          style: {"height":"100%"}
                        }),
                        _createVNode(_component_n_statistic, {
                          label: "Status",
                          style: {"text-align":"center"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_text, { type: "info" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.raceState), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_n_divider, {
                          vertical: "",
                          style: {"height":"100%"}
                        }),
                        _createVNode(_component_n_space, {
                          vertical: "",
                          size: [0, 0]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_statistic, {
                              label: "Pool",
                              style: {"text-align":"center"}
                            }, {
                              prefix: _withCtx(() => [
                                _createVNode(_component_n_text, {
                                  type: "success",
                                  style: {"margin-right":".25rem"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.currencyName), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_n_text, { type: "success" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.formatNumberDecimals(Number(_ctx.eth.utils.formatEther(_ctx.race.entryFee)) * _ctx.race.participants.length)), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.participants.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(_ctx.raceType==='live' ? 'participants' : '')
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.participants, (hound, index) => {
                  return (_openBlock(), _createBlock(_component_n_card, {
                    class: _normalizeClass([{
              owned: (hound.owner === _ctx.eth.userAddress)
            }, "hound-card-container"]),
                    key: hound.id,
                    style: {"margin-bottom":".2rem"},
                    size: _ctx.breakpoints.sDown.matches ? 'small' : 'medium',
                    onClick: ($event: any) => (_ctx.openHound(hound.id.toString()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["hound-card avatar", `
                avatar-component-${hound.extensionTraits ? hound.extensionTraits : hound.head[3]}-${hound.color[3]}
                avatar-neon-${hound.extensionTraits ? hound.extensionTraits : hound.head[3]}-${hound.color[2]}
              `])
                      }, [
                        _createElementVNode("div", null, [
                          _hoisted_9,
                          _hoisted_10,
                          _hoisted_11,
                          _createElementVNode("div", _hoisted_12, [
                            (_ctx.raceState === 'ended')
                              ? (_openBlock(), _createBlock(_component_n_text, {
                                  key: 0,
                                  type: "primary",
                                  style: {"margin-right":"1rem"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" #" + _toDisplayString(index + 1), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createElementVNode("strong", null, _toDisplayString(hound.name), 1),
                            (_ctx.ethReactive.userAddress === hound.owner && _ctx.raceType === 'join' && _ctx.canLeave(hound))
                              ? (_openBlock(), _createBlock(_component_n_button, {
                                  key: 1,
                                  style: {"margin-left":".5rem"},
                                  size: "small",
                                  onClick: ($event: any) => (_ctx.unenqueue(hound)),
                                  type: "error",
                                  ghost: "",
                                  class: "fade-in"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_13
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.raceState === 'ended' && index < _ctx.winnings.length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                  _createVNode(_component_n_space, {
                                    align: "center",
                                    style: {"display":"inline-flex"}
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_15,
                                      _createVNode(_component_n_space, {
                                        vertical: "",
                                        style: {"display":"inline-flex"},
                                        align: "center",
                                        size: [1, 1]
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_n_text, { type: "primary" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.formatNumberDecimals(_ctx.winnings[index])) + " " + _toDisplayString(_ctx.currencyName), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (_ctx.exchangeRatesAvailable && _ctx.exchangeRates[_ctx.race.entryFeeCurrency])
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                _hoisted_17,
                                                _createVNode(_component_n_text, { type: "info" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.convertToUSD(_ctx.formatNumberDecimals(_ctx.winnings[index]), false, _ctx.race.entryFeeCurrency)) + " USD", 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _hoisted_18
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_n_tag, { type: "info" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(hound.getGeneration()), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createElementVNode("div", null, _toDisplayString(hound.firstPlace - ((_ctx.participantPlacement.indexOf(hound.token_id) === 0 && _ctx.raceState !== 'ended') ? 1 : 0)) + " / " + _toDisplayString(hound.secondPlace - ((_ctx.participantPlacement.indexOf(hound.token_id) === 1 && _ctx.raceState !== 'ended') ? 1: 0)) + " / " + _toDisplayString(hound.thirdPlace - ((_ctx.participantPlacement.indexOf(hound.token_id) === 2 && _ctx.raceState !== 'ended') ? 1 : 0)), 1)
                        ])
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["class", "size", "onClick"]))
                }), 128))
              ], 2))
            : (_openBlock(), _createBlock(_component_n_alert, {
                key: 2,
                type: "info"
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })),
          (_ctx.raceType==='join')
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_component_n_space, {
                  class: "sticky-right",
                  justify: "right",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_button_group, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_button, {
                          size: "large",
                          type: "info",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refresh(false)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_icon, { size: "large" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_refresh_icon)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_n_button, {
                          disabled: _ctx.info.participants.length >= _ctx.info.totalParticipants,
                          size: "large",
                          type: "primary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.join()))
                        }, {
                          default: _withCtx(() => [
                            (_ctx.info.participants.length >= _ctx.info.totalParticipants)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_22
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_23
                                ], 64))
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : (_ctx.raceType==='live')
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_component_n_space, {
                    class: "sticky-right",
                    justify: "right",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_space, { align: "center" }, {
                        default: _withCtx(() => [
                          (['upcoming', 'live'].includes(_ctx.raceState))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Watch in"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_26, "Replay in")),
                          _createVNode(_component_n_button_group, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_n_button, {
                                size: "large",
                                type: "info",
                                onClick: _ctx.watchRace2D
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_27
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_n_button, {
                                size: "large",
                                type: "primary",
                                onClick: _ctx.watchRace3D
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_28
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
        ]))
      ]),
      _createVNode(_component_n_modal, {
        show: _ctx.showHoundSelectModal,
        "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showHoundSelectModal) = $event)),
        style: {"width":"max-content"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_hound_select_modal, {
            class: "modal",
            queue: _ctx.info,
            onJoin: _ctx.onJoined,
            onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showHoundSelectModal=false))
          }, null, 8, ["queue", "onJoin"])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }, 8, ["collapsed"]))
}